<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column
            h1.is-size-3 Inventarios
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times 
            br
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Almacén
            br
            a.button.is-dark.is-rounded(@click="irAlmacen()") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Almacenes
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Almacenes") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-user-tag.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Asignaciones
            br
            a.button.is-dark.is-rounded(@click="irAsignaciones") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-search.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Búsqueda
            br
            a.button.is-dark.is-rounded(@click="irBusqueda") Entrar
</template>


<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'InventarioAlmacen',
    components: { Loader, NavBarInventario },
    data() {
      return {
        isLoading: false,
        verAlmacenG: false,
        verAlmacenC: false,
        verSubMenu: false,
        verAsignacionCedes: false,
        almacenes: [],
        origen: {},
      }
    },
    methods: {
      irSalidas(tipo) {
        this.$store.commit('selectSalida', tipo)
        this.$router.push( {path: '/Inventario/Busqueda'})
      },
      irAlmacen() {
        if (this.userLogin.cargo === '331' || this.userLogin.cargo === '332') {
          this.$store.commit('selectAlmacen', '')
        } else {
          this.$store.commit('selectAlmacen', this.origen.clave)
        }
        this.$router.push( {path: '/Inventario/Almacen/'})
      },
      obtenerUser() {
        if (Object.keys(this.userLogin).length === 0) {
          this.$router.push('/')
        } else {
          console.log(this.userLogin.cargo)
          console.log(this.verSubMenu)
          switch (this.userLogin.cargo) {
            case '000':
              this.verAlmacenG = true
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '002':
              this.verAlmacenG = true
              this.verSubMenu = true
              break
            case '2100':
              this.verAlmacenG = true
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '2200':
              this.verAlmacenG = true
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '003':
              this.verAlmacenG = true
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '330':
              this.verSubMenu = true
              break
            case '331':
              this.verSubMenu = true
              this.verAlmacenG = true
              this.verAlmacenC = true
              break
            case '332':
              this.verAlmacenG = true
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '160':
              break
            case '210':
              this.verAlmacenG = true
              this.verSubMenu = true
              break
            case '230':
              this.verAlmacenG = true
              this.verSubMenu = true
              break
            case '240':
              break
            case '241':
              this.verAsignacionCedes = true
              break
            case '310':
              break
            case '321':
              this.verAlmacenC = true
              this.verAsignacionCedes = true
              break
            case '323':
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '324':
              this.verAlmacenC = true
              this.verSubMenu = true
              break
            case '341':
              break
            case '342':
              break
            case '343':
              break
            case '350':
              break
            case '250':
              break
            case '370':
              break
            case '270':
              break
            default:
              this.verAlmacenG = false
              this.verAlmacenC = false
              this.verSubMenu = false
              this.verAsignacionCedes = false
              break
          }
        }
      },
      irAsignaciones () {
        if (this.verSubMenu) {
          this.$store.commit('selectAlmacen', '')
          this.$router.push('/Inventario/Asignacion/SubMenu')
        } else {
          this.$store.commit('selectAlmacen', this.origen.clave)
          if (this.verAsignacionCedes) {
            this.$router.push('/Inventario/Administracion')
          } else {
            this.$router.push('/Inventario/Asignaciones')
          }
        }
      },
      obtenerAlmacenes() {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            console.log(e.message)
          })
      },
      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },
      obtenerAlmacenOrigen() {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
        this.obtenerUser()
      },
      backPage () {
        this.$router.back()
      },
      irBusqueda () {
        this.$router.push('/Inventario/Buscar')
      },
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
    },
    created () {
      this.obtenerAlmacenes()
    }
  }
</script>

<style lang="scss" scoped>
  .card-item:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Menu.vue